import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { GrUploadOption } from "react-icons/gr";

import { addDoc } from "../store/slices/mpd";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";


const AddMpd = () => {
  const user = JSON.parse(localStorage.getItem("users"));

  const token = user?.data?.accessToken;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [order, setOrder] = useState("");

  const [fileUrl, setFileUrl] = useState("");
  const [preview, setPreview] = useState("");

  const [errors, setErrors] = useState({});
  const [uploadError, setUploadError] = useState("");

  const [isDisabled, setIsDisabled] = useState(false);

  const uploadFile = async (e) => {
    setUploadError("");

    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = [
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      setUploadError("Invalid file type");
      return;
    }

    // 10 MB validation
    if (file.size > 10 * 1024 * 1024) {
      setUploadError("File size must be less than 10 MB");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(
        `${API_BASE_URL}${API_PATHS.upload}`,
        {
          method: "POST",
          headers: {
            "x-access-token": token,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (data?.status === 1 && data?.data?.location) {
        setFileUrl(data.data.location);
        setPreview(data.data.location);

        setErrors((prev) => ({
          ...prev,
          file: "",
        }));
      } else {
        setUploadError("Upload failed");
      }
    } catch (error) {
      console.log(error);
      setUploadError("Something went wrong");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsDisabled(true);

    setTimeout(() => {
      setIsDisabled(false);
    }, 3000);

    const validationErrors = {};

    if (!title.trim()) {
      validationErrors.title = "Please enter title";
    }

    if (!order) {
  validationErrors.order = "Please enter order";
}

    if (!fileUrl) {
      validationErrors.file = "Please upload file";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      title,
      order,
      file: {
        url: fileUrl,
      },
    };

    try {
      await dispatch(addDoc(payload)).unwrap();

      alert("Document added successfully");

      navigate("/admin/mpd");
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add MPD</h6>

        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/mpd"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              MPD
            </Link>
          </li>

          <li>&gt;</li>

          <li className="fw-medium">Add MPD</li>
        </ul>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* TITLE */}
              <div className="col-md-4 mb-4">
                <label className="form-label">
                  Document Title
                </label>

                <input
                  type="text"
                  className={`form-control ${
                    errors.title ? "is-invalid" : ""
                  }`}
                  placeholder="Enter document title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />

                {errors.title && (
                  <div className="text-danger mt-2">
                    {errors.title}
                  </div>
                )}
              </div>

             {/* ORDER */}
<div className="col-md-4 mb-4">
  <label className="form-label">
    Order
  </label>

<input
  type="text"
  inputMode="numeric"
  className={`form-control ${
    errors.order ? "is-invalid" : ""
  }`}
  placeholder="Enter order"
  value={order}
  onChange={(e) => {
    // allow only numbers
    const value = e.target.value.replace(/\D/g, "");

    setOrder(value);
  }}
/>

  {errors.order && (
    <div className="text-danger mt-2">
      {errors.order}
    </div>
  )}
</div>
              {/* FILE */}
              <div className="col-md-4 mb-4">
                <label className="form-label">
                  Upload File
                </label>

                <br />

                <label
                  htmlFor="fileInput"
                  className="btn btn-primary"
                >
                  <GrUploadOption />
                  &nbsp; Upload File
                </label>

                <input
                  type="file"
                  id="fileInput"
                  hidden
                  onChange={uploadFile}
                />

                {errors.file && (
                  <div className="text-danger mt-2">
                    {errors.file}
                  </div>
                )}

                {uploadError && (
                  <div className="text-danger mt-2">
                    {uploadError}
                  </div>
                )}
              </div>

              {/* PREVIEW */}
              {preview && (
                <div className="col-md-4 mb-4">
                  <label className="form-label">
                    Preview
                  </label>

                  <div>
                   
                      <a
                        href={preview}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-outline-primary"
                      >
                        View Uploaded File
                      </a>
                  
                  </div>
                </div>
              )}
            </div>

            {/* BUTTONS */}
            <div className="d-flex justify-content-center gap-3 mt-5">
              <button
                type="button"
                onClick={() => navigate(-1)}
                               className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={isDisabled}
                 className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddMpd;